<template>
  <div class="mx-auto readonly">
    <div
      v-for="(family, index) in familyMembers"
      :key="index"
      class="mb-2 p-5 bg-light"
    >
      <h4 class="form-section__title">
        Family #{{ index + 1 }}: {{ getDetail(index).forename }} {{ getDetail(index).surname }}
      </h4>
      <div class="form-section">
        <h4 class="form-section__title">
          Additional Details:
        </h4>
        <FamilyMemberForm
          :form="getDetail(index)"
          :print="true"
        />
      </div>
      <div class="form-section">
        <BmiForm
          :form-data="getAdditionalDetails(index).bmi"
          prefix="family-summary"
          :print="true"
          :is-family="true"
          :quote-verify="quoteVerify"
          :dob="getDetail(index).dateOfBirth"
        />
      </div>

      <div class="form-section">
        <SupplementaryQuestionForm
          :additional-details="getAdditionalDetails(index)"
          :prefix="'family-member-gen-' + index"
        />
      </div>

      <div class="form-section">
        <h4 class="form-section__title">
          Physician Details
        </h4>
        <PhysicalDetailsForm
          :form-data="getAdditionalDetails(index).physicianDetails"
          :prefix="`family-gen` + index"
          :print="true"
        />
      </div>

      <div
        v-if="$formData.underwritingTypeId === 1"
        class="form-section"
      >
        <h4 class="form-section__title">
          Underwriting Questions
        </h4>
        <div class="form-section__group">
          <div class="accordion">
            <div class="accordion-item mb-2 border">
              <AccordionMemberForm
                :underwriting-questions="family.underwritingQuestions"
                :prefix="`print_family_` + index"
                title="Underwriting Question"
                :print="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FamilyMemberForm from '../PolicyHolder/FamilyMemberForm.vue'
import BmiForm from '../../components/AdditionalDetails/Form/BmiForm.vue'
import SupplementaryQuestionForm from '../../components/AdditionalDetails/Form/SupplementaryQuestionForm.vue'
import PhysicalDetailsForm from '../../components/AdditionalDetails/Form/PhysicalDetailsForm.vue'
import AccordionMemberForm from '../UnderwritingQuestions/AccordionMemberForm.vue'

export default {
  name: 'PolicyHolderSummary',
  components: {
    FamilyMemberForm,
    BmiForm,
    SupplementaryQuestionForm,
    PhysicalDetailsForm,
    AccordionMemberForm,
  },
  props: {
    familyMembers: {
      type: Array,
      require: true,
      default: null,
    },
    quoteVerify: {
      type: Object,
      require: true,
      default: null,
    },
  },
  data() {
    return {
      form: this.$formData,
      policyHolder: this.$formData.policyHolder,
      additionalDetails: this.$formData.policyHolder.additionalDetails,
      physicianDetails: this.$formData.policyHolder.additionalDetails.physicianDetails,
    }
  },
  mounted() {},
  methods: {
    getFamily(index) {
      return this.$formData.familyMembers[index]
    },
    getDetail(index) {
      return this.getFamily(index).details
    },
    getAdditionalDetails(index) {
      return this.getFamily(index).additionalDetails
    },
  },
}
</script>
